<template lang='pug'>
  .color-solutions-colorist-opinion-modal.text-center
    template(v-if="!ticketCreated")
      p.modal-title.bold.xs-f-large.max-at-tweak Get a colorist's opinion
      p.modal-text.color-slate.xs-f-medium.max-at-tweak Our colorists are more than happy to review your new match. They’ll reach out to you once they’ve taken a look, then we’ll ship your free box of color ASAP.
      button.mr-btn.btn-fixed-width.xs-f-xsmall.max-at-tweak(type='button' @click='sendToColorist' :class="{disabled: creatingTicket}") send to colorist
      button.mr-btn.btn-inverse.btn-fixed-width.xs-f-xsmall.max-at-tweak(type='button' @click='cancel') cancel
    template(v-else)
      p.modal-title.bold.xs-f-large.max-at-tweak Your information has been sent to a colorist.
      p.modal-text.color-slate.xs-f-medium.max-at-tweak Thank you for reaching out.</br> Someone from our team will contact you within 24 hours.
      button.mr-btn.btn-fixed-width.xs-f-xsmall.max-at-tweak(type='button' @click='hideModal') close

</template>

<script>
  import { mapActions } from 'vuex';
  export default {
    name: "ColorSolutionsColoristOpinionModal",

    data() {
      return {
        creatingTicket: false,
        ticketCreated: false
      }
    },

    methods: {
      ...mapActions('modal', ['hideModal']),

      sendToColorist() {
        if (this.creatingTicket) {
          return;
        }
        this.creatingTicket = true;

        this.$http.post('/api/quiz/createColorSolutionZendeskTicket').then(() => {
          this.ticketCreated = true;
          this.creatingTicket = false;
        });
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .color-solutions-colorist-opinion-modal
    padding 1.5em 5%
    
    .modal-title
      padding-bottom 0.5em
      
    .modal-text
      padding-bottom 1em
    
    button
      margin-top 1em
      
    @media mq-tablet
      padding-left 10%
      padding-right 10%
    
    @media mq-desktop-md
      padding-left 15%
      padding-right 15%
      
    @media mq-desktop-plus
      padding-left 20%
      padding-right 20%
    
</style>
